export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  AGENT_LOGIN_GATE: 'agent_login_gate',
  LAST_AUTH_GATE: 'last_auth_gate',
};
